<template>

    <div class="row-card" @mouseenter="mouseIn" @mouseleave="mouseOut">
    <!-- <div class="row-card"> -->
        <div class="preview" @click.prevent="play">
            <div class="pic cvr" :style="{ backgroundImage : 'url('+ posterSrc +')' }"></div>
            <div class="tp">
                <span class="m-tag ft-bld" :style="{ background : Global.mockupConfig.colors.icons }" v-if="moneyTag">{{ moneyTag }}</span>
            </div>
            <div class="btm col">
                <span class="name-title ft-xbld">{{ title }}</span>
                <div class="progress" v-if="progressPerc">
                    <span class="inner" :style="{width: progressPerc + '%'}"></span>
                </div>
            </div>
        </div>
        <div class="extended" :class="{ active : isExtended }">
            <!-- <div class="blr"></div> -->
            <div class="top preview" @click.prevent="play">
                <div class="pic cvr" :style="{ backgroundImage : 'url('+ posterSrc +')' }"></div>
                <!-- <div class="tp">
                    <span class="m-tag ft-bld" v-if="moneyTag">{{ moneyTag }}</span>
                </div>
                <div class="btm col">
                    <span class="name-title ft-xbld">{{ title }}</span>
                    <div class="progress" v-if="progressPerc">
                        <span class="inner" :style="{width: progressPerc + '%'}"></span>
                    </div>
                </div> -->
            </div>
            <div class="bottom">
                <div class="bg"></div>
                <div class="actions">
                    <div class="btn main ply sub" @click.prevent="openSubOverlay" :style="{ background : Global.mockupConfig.colors.icons }"
                        v-if="moneyTag != 'Free'"
                    >
                        <span class="ico">
                            <svg width="21" height="24" viewBox="0 0 21 24" fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M0 4.31289C0 1.15108 3.49535 -0.760801 6.1577 0.944758L18.8143 9.05288C20.9637 10.4298 20.9637 13.5702 18.8143 14.9471L6.1577 23.0552C3.49535 24.7608 0 22.8489 0 19.6871V4.31289Z" fill="black"/>
                            </svg>
                        </span>
                        <span class="txt">Subscribe</span>
                    </div>
                    <div class="btn main ply" :style="{ background : Global.mockupConfig.colors.icons }" @click.prevent="play"
                        v-else
                    >
                        <span class="ico">
                            <svg width="21" height="24" viewBox="0 0 21 24" fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M0 4.31289C0 1.15108 3.49535 -0.760801 6.1577 0.944758L18.8143 9.05288C20.9637 10.4298 20.9637 13.5702 18.8143 14.9471L6.1577 23.0552C3.49535 24.7608 0 22.8489 0 19.6871V4.31289Z" fill="black"/>
                            </svg>
                        </span>
                        <span class="txt" v-if="progressPerc">Resume</span>
                        <span class="txt" v-if="!progressPerc && moneyTag == 'Free'">Play</span>
                    </div>
                    <div class="sqr i" @click.prevent="show">
                        <span class="ico">
                            <svg width="26" height="26" viewBox="0 0 26 26" fill="none">
                            <circle cx="13" cy="13" r="13" fill="white"/>
                            <circle cx="13" cy="7" r="2" fill="#696969"/>
                            <path d="M13 12V19" stroke="#696969" stroke-width="3" stroke-linecap="round"/>
                            </svg>
                        </span>
                    </div> 
                    <div class="sqr add">
                        <span class="ico">
                            <svg width="26" height="26" viewBox="0 0 26 26" fill="none">
                            <path d="M13 2V24" stroke="white" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M2 13H24" stroke="white" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </span>
                    </div> 
                    <div class="sqr vol">
                        <span class="ico">
                            <svg width="29" height="23" viewBox="0 0 29 23" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.5 6.91872H3.33333C2.59733 6.91872 2 7.51605 2 8.25205V14.5854C2 15.3214 2.59733 15.9187 3.33333 15.9187H6.5L11.8053 20.4134C12.672 21.1481 14 20.5321 14 19.3961V3.44138C14 2.30538 12.6707 1.68938 11.8053 2.42405L6.5 6.91872Z" fill="white" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M19.3828 16.7226C20.9321 15.76 22.0001 13.7573 22.0001 11.4253C22.0001 9.09329 20.9321 7.08929 19.3828 6.11462" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M23.3407 20.8387C25.7513 18.7653 27.334 15.3253 27.334 11.4227C27.334 7.51467 25.7487 4.072 23.334 2" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </span>
                    </div> 
                </div>
                <p class="sum">{{ description }}</p>
            </div>
        </div>
    </div>

</template>

<script>

    import Global from '../lib/GlobalState'

    export default {

        name: 'RowCard',

        props: {
            posterSrc: String,
            moneyTag: String,
            title: String,
            description: String,
            progressPerc: Number,
            index: Number
        },

        data() {
            return {
                Global,
                interval: '',
                isExtended: false,
                isOut: true
            }
        },

        methods: {

            mouseIn() {
                this.isOut = false
                this.interval = setInterval(function() {
                    clearInterval(this.interval)
                    setTimeout(() => {
                        if (this.isOut) return
                        this.isExtended = true
                        this.$parent.hoveredCard(true)
                    }, 150)
                }.bind(this), 100);
            },

            mouseOut() {
                this.isOut = true
                this.isExtended = false
                this.$parent.hoveredCard(false)
                clearInterval(this.interval)
            },

            openSubOverlay() {
                this.Global.tempSubClosingOverlay = false
                this.Global.activeSubOverlay = true
                this.Global.activeSubInfoOverlay = true
            },

            async play() {

                const parentName = this.$parent.$parent.$options.name
                if(parentName == "PreviewInfoOverlay") {
                    await this.$parent.$parent.closeOverlay()
                }


                if(this.moneyTag != "Free") {
                    return this.openSubOverlay()
                }

                this.Global.assetIndexToPlay = this.index
                this.$router.push("/player")
            },

            async show() {
                const parentName = this.$parent.$parent.$options.name
                if(parentName == "PreviewInfoOverlay") {
                    await this.$parent.$parent.closeOverlay()
                }

                this.Global.assetIndexToShow = this.index
                this.$parent.$parent.$parent.openInfoOverlay()
            }
        }
    }
</script>